// src/components/Admin/CalendarioScadenze.jsx
import React, { useState, useEffect } from 'react';
import { collection, getDocs, query, where } from 'firebase/firestore';
import { db } from '../../firebase';
import './CalendarioScadenze.css';

const CalendarioScadenze = () => {
  // ==============================
  // STATI
  // ==============================
  const [viewMode, setViewMode] = useState('settimanale'); // 'settimanale' | 'mensile'
  const [currentDate, setCurrentDate] = useState(new Date());
  const [scadenzePersonale, setScadenzePersonale] = useState([]);
  const [scadenzeMezzi, setScadenzeMezzi] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [filtroTipo, setFiltroTipo] = useState('tutti'); // 'tutti' | 'personale' | 'mezzi'
  const [filtroUrgenza, setFiltroUrgenza] = useState('tutti'); // 'tutti' | 'scaduto' | 'urgente' | 'prossimo'

  // ==============================
  // CARICAMENTO DATI
  // ==============================
  useEffect(() => {
    loadScadenze();
  }, []);

  const loadScadenze = async () => {
    try {
      setIsLoading(true);
      
      // Carica scadenze personale
      const usersSnapshot = await getDocs(collection(db, 'users'));
      const scadenzePersonaleTemp = [];

      usersSnapshot.docs.forEach(doc => {
        const data = doc.data();
        const displayName = `${data.nome || ''} ${data.cognome || ''}`.trim() || data.email;

        // Contratto determinato
        if (data.tipoContratto === 'determinato' && data.dataScadenzaContratto) {
          scadenzePersonaleTemp.push({
            id: `contratto-${doc.id}`,
            tipo: 'personale',
            categoria: 'Contratto',
            descrizione: `Scadenza contratto - ${displayName}`,
            data: data.dataScadenzaContratto.toDate ? data.dataScadenzaContratto.toDate() : new Date(data.dataScadenzaContratto),
            userId: doc.id,
            userName: displayName,
            icon: '📋'
          });
        }

        // Visita medica
        if (data.dataScadenzaVisitaMedica) {
          scadenzePersonaleTemp.push({
            id: `visita-${doc.id}`,
            tipo: 'personale',
            categoria: 'Visita Medica',
            descrizione: `Visita medica - ${displayName}`,
            data: data.dataScadenzaVisitaMedica.toDate ? data.dataScadenzaVisitaMedica.toDate() : new Date(data.dataScadenzaVisitaMedica),
            userId: doc.id,
            userName: displayName,
            icon: '🏥'
          });
        }
      });

      // Carica scadenze mezzi
      const mezziSnapshot = await getDocs(collection(db, 'mezzi'));
      const scadenzeMezziTemp = [];

      mezziSnapshot.docs.forEach(doc => {
        const data = doc.data();
        const nomeMezzo = data.nomeMezzo || data.nome || `Mezzo ${doc.id}`;

        // Bollo
        if (data.dataScadenzaBollo) {
          scadenzeMezziTemp.push({
            id: `bollo-${doc.id}`,
            tipo: 'mezzo',
            categoria: 'Bollo',
            descrizione: `Bollo - ${nomeMezzo}`,
            data: data.dataScadenzaBollo.toDate ? data.dataScadenzaBollo.toDate() : new Date(data.dataScadenzaBollo),
            mezzoId: doc.id,
            mezzoNome: nomeMezzo,
            targa: data.targa || '',
            icon: '🚗'
          });
        }

        // Revisione
        if (data.dataScadenzaRevisione) {
          scadenzeMezziTemp.push({
            id: `revisione-${doc.id}`,
            tipo: 'mezzo',
            categoria: 'Revisione',
            descrizione: `Revisione - ${nomeMezzo}`,
            data: data.dataScadenzaRevisione.toDate ? data.dataScadenzaRevisione.toDate() : new Date(data.dataScadenzaRevisione),
            mezzoId: doc.id,
            mezzoNome: nomeMezzo,
            targa: data.targa || '',
            icon: '🔧'
          });
        }

        // Assicurazione
        if (data.dataScadenzaAssicurazione) {
          scadenzeMezziTemp.push({
            id: `assicurazione-${doc.id}`,
            tipo: 'mezzo',
            categoria: 'Assicurazione',
            descrizione: `Assicurazione - ${nomeMezzo}`,
            data: data.dataScadenzaAssicurazione.toDate ? data.dataScadenzaAssicurazione.toDate() : new Date(data.dataScadenzaAssicurazione),
            mezzoId: doc.id,
            mezzoNome: nomeMezzo,
            targa: data.targa || '',
            icon: '🛡️'
          });
        }

        // Tagliando
        if (data.dataScadenzaTagliando) {
          scadenzeMezziTemp.push({
            id: `tagliando-${doc.id}`,
            tipo: 'mezzo',
            categoria: 'Tagliando',
            descrizione: `Tagliando - ${nomeMezzo}`,
            data: data.dataScadenzaTagliando.toDate ? data.dataScadenzaTagliando.toDate() : new Date(data.dataScadenzaTagliando),
            mezzoId: doc.id,
            mezzoNome: nomeMezzo,
            targa: data.targa || '',
            icon: '🔧'
          });
        }
      });

      setScadenzePersonale(scadenzePersonaleTemp);
      setScadenzeMezzi(scadenzeMezziTemp);
    } catch (error) {
      console.error('Errore nel caricamento scadenze:', error);
    } finally {
      setIsLoading(false);
    }
  };

  // ==============================
  // FUNZIONI UTILITÀ
  // ==============================
  const getUrgenza = (data) => {
    const oggi = new Date();
    oggi.setHours(0, 0, 0, 0);
    const dataScadenza = new Date(data);
    dataScadenza.setHours(0, 0, 0, 0);
    
    const diffGiorni = Math.ceil((dataScadenza - oggi) / (1000 * 60 * 60 * 24));
    
    if (diffGiorni < 0) return 'scaduto';
    if (diffGiorni <= 7) return 'urgente';
    if (diffGiorni <= 30) return 'prossimo';
    return 'normale';
  };

  const getUrgenzaClass = (urgenza) => {
    switch (urgenza) {
      case 'scaduto': return 'urgenza-scaduto';
      case 'urgente': return 'urgenza-urgente';
      case 'prossimo': return 'urgenza-prossimo';
      default: return 'urgenza-normale';
    }
  };

  const getUrgenzaLabel = (urgenza) => {
    switch (urgenza) {
      case 'scaduto': return 'SCADUTO';
      case 'urgente': return 'Urgente (≤7gg)';
      case 'prossimo': return 'Prossimo (≤30gg)';
      default: return 'Normale';
    }
  };

  const formatDate = (date) => {
    return new Date(date).toLocaleDateString('it-IT', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric'
    });
  };

  const getGiorniRimanenti = (data) => {
    const oggi = new Date();
    oggi.setHours(0, 0, 0, 0);
    const dataScadenza = new Date(data);
    dataScadenza.setHours(0, 0, 0, 0);
    
    const diffGiorni = Math.ceil((dataScadenza - oggi) / (1000 * 60 * 60 * 24));
    
    if (diffGiorni < 0) return `Scaduto da ${Math.abs(diffGiorni)} giorni`;
    if (diffGiorni === 0) return 'Scade oggi';
    if (diffGiorni === 1) return 'Scade domani';
    return `Tra ${diffGiorni} giorni`;
  };

  // ==============================
  // FUNZIONI NAVIGAZIONE DATE
  // ==============================
  const goToToday = () => {
    setCurrentDate(new Date());
  };

  const navigateWeek = (direction) => {
    const newDate = new Date(currentDate);
    newDate.setDate(newDate.getDate() + (direction * 7));
    setCurrentDate(newDate);
  };

  const navigateMonth = (direction) => {
    const newDate = new Date(currentDate);
    newDate.setMonth(newDate.getMonth() + direction);
    setCurrentDate(newDate);
  };

  // ==============================
  // CALCOLO RANGE DATE
  // ==============================
  const getWeekRange = () => {
    const start = new Date(currentDate);
    start.setDate(start.getDate() - start.getDay() + 1); // Lunedì
    start.setHours(0, 0, 0, 0);
    
    const end = new Date(start);
    end.setDate(end.getDate() + 13); // Due settimane
    end.setHours(23, 59, 59, 999);
    
    return { start, end };
  };

  const getMonthRange = () => {
    const start = new Date(currentDate.getFullYear(), currentDate.getMonth(), 1);
    start.setHours(0, 0, 0, 0);
    
    const end = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 0);
    end.setHours(23, 59, 59, 999);
    
    return { start, end };
  };

  const getCurrentRange = () => {
    return viewMode === 'settimanale' ? getWeekRange() : getMonthRange();
  };

  // ==============================
  // FILTRAGGIO SCADENZE
  // ==============================
  const getScadenzeFiltrate = () => {
    let tutte = [...scadenzePersonale, ...scadenzeMezzi];
    
    // Filtro per tipo
    if (filtroTipo === 'personale') {
      tutte = tutte.filter(s => s.tipo === 'personale');
    } else if (filtroTipo === 'mezzi') {
      tutte = tutte.filter(s => s.tipo === 'mezzo');
    }
    
    // Filtro per urgenza
    if (filtroUrgenza !== 'tutti') {
      tutte = tutte.filter(s => getUrgenza(s.data) === filtroUrgenza);
    }
    
    // Filtro per range date visualizzato
    const { start, end } = getCurrentRange();
    tutte = tutte.filter(s => {
      const dataScadenza = new Date(s.data);
      return dataScadenza >= start && dataScadenza <= end;
    });
    
    // Ordina per data
    tutte.sort((a, b) => new Date(a.data) - new Date(b.data));
    
    return tutte;
  };

  // ==============================
  // GENERAZIONE GIORNI SETTIMANA
  // ==============================
  const getWeekDays = () => {
    const { start } = getWeekRange();
    const days = [];
    
    for (let i = 0; i < 14; i++) {
      const day = new Date(start);
      day.setDate(day.getDate() + i);
      days.push(day);
    }
    
    return days;
  };

  // ==============================
  // GENERAZIONE GIORNI MESE
  // ==============================
  const getMonthDays = () => {
    const { start, end } = getMonthRange();
    const days = [];
    
    // Giorni prima del mese (per completare la prima settimana)
    const firstDayOfWeek = start.getDay();
    const daysToAdd = firstDayOfWeek === 0 ? 6 : firstDayOfWeek - 1;
    
    for (let i = daysToAdd; i > 0; i--) {
      const day = new Date(start);
      day.setDate(day.getDate() - i);
      days.push({ date: day, isCurrentMonth: false });
    }
    
    // Giorni del mese corrente
    const current = new Date(start);
    while (current <= end) {
      days.push({ date: new Date(current), isCurrentMonth: true });
      current.setDate(current.getDate() + 1);
    }
    
    // Giorni dopo il mese (per completare l'ultima settimana)
    const remainingDays = 7 - (days.length % 7);
    if (remainingDays < 7) {
      for (let i = 1; i <= remainingDays; i++) {
        const day = new Date(end);
        day.setDate(day.getDate() + i);
        days.push({ date: day, isCurrentMonth: false });
      }
    }
    
    return days;
  };

  // ==============================
  // FUNZIONI HELPER GIORNI
  // ==============================
  const isToday = (date) => {
    const today = new Date();
    return date.toDateString() === today.toDateString();
  };

  const getScadenzeGiorno = (date) => {
    const scadenze = getScadenzeFiltrate();
    return scadenze.filter(s => {
      const dataScadenza = new Date(s.data);
      return dataScadenza.toDateString() === date.toDateString();
    });
  };

  // ==============================
  // STATISTICHE
  // ==============================
  const getStatistiche = () => {
    const tutte = [...scadenzePersonale, ...scadenzeMezzi];
    
    return {
      totali: tutte.length,
      scadute: tutte.filter(s => getUrgenza(s.data) === 'scaduto').length,
      urgenti: tutte.filter(s => getUrgenza(s.data) === 'urgente').length,
      prossime: tutte.filter(s => getUrgenza(s.data) === 'prossimo').length,
      personale: scadenzePersonale.length,
      mezzi: scadenzeMezzi.length
    };
  };

  // ==============================
  // RENDER
  // ==============================
  if (isLoading) {
    return (
      <div className="calendario-container">
        <div className="loading-spinner">
          <div className="spinner"></div>
          <p>Caricamento scadenze...</p>
        </div>
      </div>
    );
  }

  const scadenzeFiltrate = getScadenzeFiltrate();
  const stats = getStatistiche();
  const { start, end } = getCurrentRange();

  return (
    <div className="calendario-container">
      {/* HEADER */}
      <div className="calendario-header">
        <div className="header-title">
          <h2>📅 Calendario Scadenze</h2>
          <p className="header-subtitle">
            Gestione scadenze personale e parco veicoli
          </p>
        </div>

        {/* STATISTICHE RAPIDE */}
        <div className="stats-cards">
          <div className="stat-card stat-scadute">
            <div className="stat-icon">⚠️</div>
            <div className="stat-content">
              <div className="stat-value">{stats.scadute}</div>
              <div className="stat-label">Scadute</div>
            </div>
          </div>
          <div className="stat-card stat-urgenti">
            <div className="stat-icon">🔴</div>
            <div className="stat-content">
              <div className="stat-value">{stats.urgenti}</div>
              <div className="stat-label">Urgenti ≤7gg</div>
            </div>
          </div>
          <div className="stat-card stat-prossime">
            <div className="stat-icon">🟡</div>
            <div className="stat-content">
              <div className="stat-value">{stats.prossime}</div>
              <div className="stat-label">Prossime ≤30gg</div>
            </div>
          </div>
          <div className="stat-card stat-totali">
            <div className="stat-icon">📊</div>
            <div className="stat-content">
              <div className="stat-value">{stats.totali}</div>
              <div className="stat-label">Totali</div>
            </div>
          </div>
        </div>
      </div>

      {/* CONTROLLI */}
      <div className="calendario-controls">
        {/* Navigazione Date */}
        <div className="date-navigation">
          <button 
            className="nav-btn"
            onClick={() => viewMode === 'settimanale' ? navigateWeek(-1) : navigateMonth(-1)}
          >
            ← Indietro
          </button>
          
          <div className="current-period">
            {viewMode === 'settimanale' ? (
              <span>
                {start.toLocaleDateString('it-IT', { day: '2-digit', month: 'short' })} - {' '}
                {end.toLocaleDateString('it-IT', { day: '2-digit', month: 'short', year: 'numeric' })}
              </span>
            ) : (
              <span>
                {currentDate.toLocaleDateString('it-IT', { month: 'long', year: 'numeric' })}
              </span>
            )}
          </div>
          
          <button className="nav-btn nav-today" onClick={goToToday}>
            Oggi
          </button>
          
          <button 
            className="nav-btn"
            onClick={() => viewMode === 'settimanale' ? navigateWeek(1) : navigateMonth(1)}
          >
            Avanti →
          </button>
        </div>

        {/* Toggle Vista */}
        <div className="view-toggle">
          <button
            className={`toggle-btn ${viewMode === 'settimanale' ? 'active' : ''}`}
            onClick={() => setViewMode('settimanale')}
          >
            📅 Settimanale
          </button>
          <button
            className={`toggle-btn ${viewMode === 'mensile' ? 'active' : ''}`}
            onClick={() => setViewMode('mensile')}
          >
            📆 Mensile
          </button>
        </div>

        {/* Filtri */}
        <div className="filters">
          <select 
            className="filter-select"
            value={filtroTipo}
            onChange={(e) => setFiltroTipo(e.target.value)}
          >
            <option value="tutti">Tutti</option>
            <option value="personale">👥 Personale</option>
            <option value="mezzi">🚗 Mezzi</option>
          </select>

          <select 
            className="filter-select"
            value={filtroUrgenza}
            onChange={(e) => setFiltroUrgenza(e.target.value)}
          >
            <option value="tutti">Tutte le urgenze</option>
            <option value="scaduto">⚠️ Scadute</option>
            <option value="urgente">🔴 Urgenti</option>
            <option value="prossimo">🟡 Prossime</option>
          </select>
        </div>
      </div>

      {/* CALENDARIO */}
      <div className="calendario-content">
        {viewMode === 'settimanale' ? (
          /* VISTA SETTIMANALE (2 settimane) */
          <div className="week-view">
            <div className="week-grid">
              {getWeekDays().map((day, index) => {
                const scadenzeGiorno = getScadenzeGiorno(day);
                const isTodayDay = isToday(day);
                
                return (
                  <div 
                    key={index} 
                    className={`day-column ${isTodayDay ? 'today' : ''}`}
                  >
                    <div className="day-header">
                      <div className="day-name">
                        {day.toLocaleDateString('it-IT', { weekday: 'short' })}
                      </div>
                      <div className="day-number">
                        {day.getDate()}
                      </div>
                      <div className="day-month">
                        {day.toLocaleDateString('it-IT', { month: 'short' })}
                      </div>
                    </div>
                    
                    <div className="day-scadenze">
                      {scadenzeGiorno.length === 0 ? (
                        <div className="no-scadenze">Nessuna scadenza</div>
                      ) : (
                        scadenzeGiorno.map(scadenza => {
                          const urgenza = getUrgenza(scadenza.data);
                          return (
                            <div 
                              key={scadenza.id}
                              className={`scadenza-card ${getUrgenzaClass(urgenza)}`}
                            >
                              <div className="scadenza-icon">{scadenza.icon}</div>
                              <div className="scadenza-info">
                                <div className="scadenza-categoria">{scadenza.categoria}</div>
                                <div className="scadenza-nome">
                                  {scadenza.tipo === 'personale' ? scadenza.userName : scadenza.mezzoNome}
                                </div>
                                {scadenza.targa && (
                                  <div className="scadenza-targa">{scadenza.targa}</div>
                                )}
                              </div>
                              <div className={`scadenza-badge ${getUrgenzaClass(urgenza)}`}>
                                {urgenza === 'scaduto' ? '⚠️' : urgenza === 'urgente' ? '🔴' : '🟡'}
                              </div>
                            </div>
                          );
                        })
                      )}
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        ) : (
          /* VISTA MENSILE */
          <div className="month-view">
            {/* Header giorni settimana */}
            <div className="month-header">
              {['Lun', 'Mar', 'Mer', 'Gio', 'Ven', 'Sab', 'Dom'].map(day => (
                <div key={day} className="weekday-header">{day}</div>
              ))}
            </div>
            
            {/* Griglia giorni */}
            <div className="month-grid">
              {getMonthDays().map((dayObj, index) => {
                const { date, isCurrentMonth } = dayObj;
                const scadenzeGiorno = getScadenzeGiorno(date);
                const isTodayDay = isToday(date);
                
                return (
                  <div 
                    key={index}
                    className={`month-day ${!isCurrentMonth ? 'other-month' : ''} ${isTodayDay ? 'today' : ''}`}
                  >
                    <div className="day-number">{date.getDate()}</div>
                    
                    {scadenzeGiorno.length > 0 && (
                      <div className="day-indicators">
                        {scadenzeGiorno.slice(0, 3).map(scadenza => {
                          const urgenza = getUrgenza(scadenza.data);
                          return (
                            <div 
                              key={scadenza.id}
                              className={`indicator ${getUrgenzaClass(urgenza)}`}
                              title={scadenza.descrizione}
                            >
                              {scadenza.icon}
                            </div>
                          );
                        })}
                        {scadenzeGiorno.length > 3 && (
                          <div className="indicator-more">
                            +{scadenzeGiorno.length - 3}
                          </div>
                        )}
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          </div>
        )}
      </div>

      {/* LISTA DETTAGLIATA */}
      <div className="scadenze-list">
        <div className="list-header">
          <h3>Dettaglio Scadenze ({scadenzeFiltrate.length})</h3>
        </div>
        
        {scadenzeFiltrate.length === 0 ? (
          <div className="empty-state">
            <div className="empty-icon">📭</div>
            <p>Nessuna scadenza nel periodo selezionato</p>
          </div>
        ) : (
          <div className="scadenze-table">
            {scadenzeFiltrate.map(scadenza => {
              const urgenza = getUrgenza(scadenza.data);
              return (
                <div key={scadenza.id} className={`scadenza-row ${getUrgenzaClass(urgenza)}`}>
                  <div className="row-icon">{scadenza.icon}</div>
                  
                  <div className="row-info">
                    <div className="row-categoria">{scadenza.categoria}</div>
                    <div className="row-nome">
                      {scadenza.tipo === 'personale' ? (
                        <span>👤 {scadenza.userName}</span>
                      ) : (
                        <span>
                          🚗 {scadenza.mezzoNome}
                          {scadenza.targa && ` - ${scadenza.targa}`}
                        </span>
                      )}
                    </div>
                  </div>
                  
                  <div className="row-data">
                    <div className="data-value">{formatDate(scadenza.data)}</div>
                    <div className={`data-giorni ${getUrgenzaClass(urgenza)}`}>
                      {getGiorniRimanenti(scadenza.data)}
                    </div>
                  </div>
                  
                  <div className={`row-badge ${getUrgenzaClass(urgenza)}`}>
                    {getUrgenzaLabel(urgenza)}
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
};

export default CalendarioScadenze;